<script setup>
import { NuxtLink } from '#components'

const props = defineProps({
  slide: {
    type: Object,
    required: true,
  },
})
</script>

<template>
  <component
    :is="props.slide.button?.to ? NuxtLink : 'div'"
    :to="props.slide.button?.to"
    class="slide d-flex"
  >
    <div class="slide__image">
      <NuxtImg
        v-if="props.slide?.image?.src"
        sizes="sm:340px md:440px lg:800px"
        densities="1x 2x"
        :src="props.slide.image.src"
        :alt="props.slide.image.alt"
        class="img-fluid"
        loading="lazy"
        :placeholder="[300, 200, 60, 2]"
      />
    </div>
    <div class="d-flex flex-column slide__content">
      <h3 class="scale-1 scale-1--bold slide__text">
        {{ props.slide.title }}
      </h3>
      <FormButton
        v-if="props.slide?.button?.label"
        class="l-button--outlined slide__button"
        :label="props.slide.button.label"
        :to="props.slide.button?.to"
        :rel="props.slide.button.rel"
        :component="props.slide.button?.to ? 'span' : 'NuxtLink'"
      />
    </div>
  </component>
</template>

<style lang="scss" scoped>
@import '~/assets/scss/variables.scss';
@import 'bootstrap/scss/mixins';

.slide {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  &__zoom {
    color: red;
    &:hover,
    &:focus,
    &:active {
      img {
        transition: transform 0.5s ease;
        transform: scale(1.05);
      }
    }
  }
  &__image {
    position: relative;
    display: flex;
    width: 100%;
    height: auto;

    img {
      position: relative;
      display: flex;
      object-fit: cover;
      min-width: 100%;
      min-height: 100%;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 100%;
      background: linear-gradient(
        rgba(0, 0, 0, 0.1) 0%,
        rgba(0, 0, 0, 0.1) 30%,
        rgba(0, 0, 0, 0.5) 70%,
        rgba(0, 0, 0, 0.5) 100%
      );
    }
  }

  &__content {
    position: absolute;
    text-align: left;
    bottom: 0;
    left: 0;
    padding: 38px;
    height: 100%;
    width: 100%;

    @include media-breakpoint-down(640) {
      padding: 25px 20px;
    }
  }

  &__text {
    margin-top: auto;
    text-transform: uppercase;
  }

  &__button {
    margin-top: 24px;
  }
}
</style>
